
import { Box, Typography, makeStyles } from "@material-ui/core";




   const useStyles = makeStyles({
	   
	   container:{
		   height: 350,
		   margin: 10,
		   border: '1px solid #d3cede',
		   borderRadius: 10, 
		   alignItems: 'center',
		   display: 'flex',
		   flexDirection: 'column',
		   '& > *': {
		   padding: '0 5px 5px 5px'
	        
		   }
	   },
	   
	   image: {
		   
		   height: 150,
		   width: '100%',
		   objectFit: 'cover',
		   borderRadius: '10px 10px 0 0'
	   },
	   
	   
	   text: {
		   color: '#878787',
		   fontSize: 12
		   
	   },
	   
	   heading: {
		   
		   fontSize: 18,
		   fontWeight: 600
		   
		   
	   },
	   
	   detail: {
		 
		 fontSize: 14,
		 wordBreak: 'break-word'
		   
		   
	   }
	   
   })

 

const Postdata = () => {
	const classes = useStyles();
	const url = `https://blogger.googleusercontent.com/img/a/AVvXsEhQPXZ3yq5kWsCs2G6h2XtGDTXv0WoX3DhkoVIPmbrR8c8_pHYi1Hsrk92t7mZokweUShLYNWZMkP4N5dmEtLqWnfv0CisRwsMCKRh5TrOock1fPqVuP8R3OMqe6XH_LT_uQAqi4tXzzo9jxXFMyOjsonVNNp0UopBjL3SfIu9AwFFh9bekBGl7tGAlsA=w640-h360`
	
	return (
     
<>

   	
       <Box className= {classes.container}>	
	
            <img src={url} className={classes.image}/>

               <Typography className={classes.text}>Penetration Testing</Typography>
               <Typography className={classes.heading}>Black Hat Pentesting</Typography>
               <Typography className={classes.text}>Author: Hacking Truth</Typography>
               <Typography className={classes.detail}>All about Penetration Testing</Typography>
             

     </Box>
	 
	 </>
	
	)
}


export default Postdata;